module.exports = __webpack_public_path__ + "static/banner_a.5a8b86cc.png";